import { LogoImg, NameText, Wrapper } from './BrandHeader.styles';
import type { BrandHeaderProps } from './BrandHeader.types';

export function BrandHeader({ propertyName, logoUrl }: BrandHeaderProps) {
  return (
    <Wrapper>
      {logoUrl ? (
        <LogoImg src={logoUrl} alt={propertyName} loading="eager" />
      ) : (
        <NameText>{propertyName}</NameText>
      )}
    </Wrapper>
  );
}
